export function hasGetter(instance: object, getter: string): boolean {
  return !!Object.getOwnPropertyDescriptor(Object.getPrototypeOf(instance), getter);
}

export function getOwnProperties(instance: Record<string, unknown>): string[] {
  return Object.getOwnPropertyNames(instance).filter(
    (prop: string) =>
      !Object.getOwnPropertyNames(new (Object.getPrototypeOf(instance.constructor))()).includes(
        prop
      )
  );
}
